<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-sm-12 ml-auto mr-auto">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left p-0 m-0">Ocorrências</h4>
          <h3 slot="header" class="card-title text-left p-0 m-0">{{ moment(ocorrencia.data).format('DD/MM/YYYY') }}</h3>

          <div class="row m-0 p-0">
            <div class="col-12 p-2 text-left">
              <base-input label="Título" type="text" placeholder="Título" v-model="ocorrencia.titulo"
                :class="erros.titulo === true ? 'has-danger' : ''">
              </base-input>
            </div>

            <div class="col-12 p-2 text-left">
              <base-input label="Descrição" type="text" placeholder="Descrição" v-model="ocorrencia.descricao"
                :class="erros.descricao === true ? 'has-danger' : ''">
              </base-input>
            </div>
          </div>

          <div class="row m-0 p-0" v-if="ocorrencias.length > 0">
            <div class="table-responsive mt-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Título</th>
                    <th scope="col">Descrição</th>
                    <th scope="col">Data</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item of ocorrencias" :key="item.id">
                    <td>{{ item.titulo }}</td>
                    <td>{{ item.descricao }}</td>
                    <td>{{ moment(item.data).format('DD/MM/YYYY') }}</td>
                    <td>
                      <el-tooltip content="Excluir" effect="light" :open-delay="300" placement="top">
                        <base-button class="remove btn-link" type="danger" size="sm" icon
                          @click="deletarOcorrencias(item.id)">
                          <i class="tim-icons icon-simple-remove"></i>
                        </base-button>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row m-0 p-0">
            <div class="col-md-6 col-sm-6 p-2">
              <base-button @click="fecharModalOcorrencia(false)" native-type="fail" type="danger" class="mb-3" size="lg"
                block>
                Fechar
              </base-button>
            </div>

            <div class="col-md-6 col-sm-6 p-2">
              <base-button @click="enviarOcorrencias()" native-type="submit" type="success" class="mb-3" size="lg"
                block>
                Salvar
              </base-button>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" loader="spinner" color="#35a887" :is-full-page="true">
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BaseInput,
} from "@/components/index";
import {
  Select,
  Option,
  TimeSelect,
  DatePicker,
} from "element-ui";
import swal from "sweetalert2";

export default {
  name: "OcorrenciasInserir",
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput
  },
  props: {
    dados: "",
    funcionario: ""
  },
  data() {
    return {
      carregarHorarios: false, //controlar o emmit que dispara para carregar ou nao os horario da tela pai
      ocorrencias: [],
      ocorrencia: {
        data: "",
        titulo: "",
        descricao: ""
      },
      isLoading: false,
      erros: {
        titulo: "",
        descricao: ""
      },
    };
  },
  created() {
  },
  mounted() {
    this.carregarDados();
  },
  methods: {
    carregarDados() {
      // carrega na tela
      this.ocorrencia.data = this.dados.day;
      this.listarOcorrencias();
    },
    deletarOcorrencias(id) {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.funcionario,
        id: id
      };
      this.axios
        .post("/api/ocorrencias/deletar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          if (response.data.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Ocorência deletada com sucesso!",
              "success"
            );
            th.carregarHorarios = true;
            th.listarOcorrencias(true);

          } else {
            th.showSwal("auto-close", "Erro", "Erro ao deletar ocorência!", "error");
          }
        })
        .catch((err) => {
          console.log(err)
          th.showSwal("auto-close", "Erro", "Erro ao deletar ocorência!", "error");
        });
    },
    listarOcorrencias() {
      let th = this;
      console.log('this.funcionario', this.funcionario)
      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.funcionario,
        dataInicial: this.dados.day,
        dataFinal: this.dados.day
      };
      th.isLoading = true;
      this.axios
        .post("/api/ocorrencias/listar", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.ocorrencias = response.data.data.dados;
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err)
          th.showSwal("auto-close", "Erro", "Erro ao carregar abonos!", "error");
        });
    },
    enviarOcorrencias() {
      const th = this;

      if (this.validarDados()) {
        this.isLoading = true;
        const formData = {
          setDB: this.$cookies.get("db"),
          id_funcionario: this.funcionario,
          data_ocorrencia: this.ocorrencia.data,
          titulo: this.ocorrencia.titulo,
          descricao: this.ocorrencia.descricao,
        };

        this.axios
          .post("/api/ocorrencias/criar", formData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
          .then(() => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Ocorrência cadastrada com sucesso!",
              "success"
            );
            th.carregarHorarios = true;
            th.fecharModalOcorrencia(true);
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao enviar ocorrência!",
              "error"
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Você precisa preencher todos os campos",
          "error"
        );
      }
    },
    validarDados() {
      let status = true;

      if (this.ocorrencia.titulo && this.ocorrencia.titulo !== "") {
        this.erros.titulo = false;
      } else {
        this.erros.titulo = true;
        status = false;
      }

      if (this.ocorrencia.descricao && this.ocorrencia.descricao !== "") {
        this.erros.descricao = false;
      } else {
        this.erros.descricao = true;
        status = false;
      }

      return status;
    },
    fecharModalOcorrencia() {
      this.$emit("fecharModalOcorrencia", this.carregarHorarios);
    },
    moment: function (data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  }
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
